import { createMuiTheme } from '@material-ui/core/styles'

const darker = '#232931'
const dark = '#393e46'
const accent = '#4ecca3'
const light = '#eeeeee'

export default createMuiTheme({
	palette: {
		type: 'dark',
		common: {
			dark: dark,
			darker: darker,
			accent: accent,
			light: light,
		},
		primary: {
			main: dark,
		},
		secondary: {
			main: accent,
		},
		background: {
			default: darker,
			paper: dark,
		},
	},
	mixins: {
		toolbar: {
			minHeight: 41.3,
		},
	},
	typography: {
		h1: {
			color: accent,
		},
	},
	overrides: {
		tabs: {
			backgroundColor: accent,
		},
		MuiInput: {
			underline: {
				'&&&&:hover:before': {
					border: 'none',
				},
			},
		},
	},
})
